import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectEntradaState = ( state: AppState ) => state.entrada;
export const selectEntrada = createSelector(selectEntradaState, (state) => state);
export const selectEntradaTema = createSelector(selectEntradaState, (state) => state.tema);
export const selectEntradaEmpresa = createSelector(selectEntradaState, (state) => state.empresa);